module.exports = __webpack_public_path__ + "img/loginArrow.eae471b8.svg";